import {register} from '@shopify/theme-sections';

import initHowToUseVideos from '../components/product-how-to-use';

export default register('product-how-to-use', {
  onLoad() {
    initHowToUseVideos(this.container);
  },
});
